import client, { apiNode, apiOri, apiStaging } from "./client";

export const getTestList = (payload) => apiNode.post("/RBD/Service", payload);
export const getPackageList = (payload) => {
  // Prefer build-time env var, fall back to runtime localStorage, then default to IN
  // const buildCountry = (process.env.REACT_APP_COUNTRY || "").toString();
  const runtimeCountry = (localStorage.getItem("country") || "").toString();
  const country = (runtimeCountry || "IND").toUpperCase();

  // Use different endpoint based on country (NP -> Nepal)
  const endpoint = country === "NP" ? "/RBD/OnlyPackage" : "/RBD/OnlyPackageNew";
  return apiNode.post(endpoint, payload);
};
export const getCompareList = (payload) => apiNode.post("/compare", payload);
export const getBranchList = () => apiNode.post("/Doctor/Centre");
export const getProfileStatus = (payload) =>
  apiNode.post("/Patient/Profile", payload);
export const getOtp = (payload) => apiOri.post("/Patient/GenerateOTP", payload);
export const validateOtp = (payload) =>
  apiOri.post("/Patient/ValidateOTP", payload);
export const getFaqCategory = (payload) =>
  apiNode.post("/getFaqCategory", payload);
export const getFaqdetails = (payload) =>
  apiNode.post("/getFaqdetails", payload);
export const getServicelist = (payload) =>
  apiNode.post("/getServicelist", payload);
export const getServiceDetails = (payload) =>
  apiNode.post("/getServiceDetails", payload);
export const getB2B = (payload) => apiNode.post("/getB2B", payload);
export const checkValidAppointment = (payload) =>
  apiNode.post("/HomeCollection/ValidRequest", payload);
export const registeredPatient = (payload) =>
  apiNode.post("/Patient/Registration", payload);
export const bookHomeCollection = (payload) =>
  apiNode.post("/HomeCollection/BookHCRequest", payload);
export const getVisitLog = (payload) => apiNode.post("/visitLog", payload);
export const getDoctorList = (payload) => apiNode.post("/Doctor/List", payload);

export const getDoctorListPagination = (payload) =>
  apiNode.post("/Doctor/ListPagination", payload);
export const getDoctorInfo = (payload) =>
  apiNode.post("/getAllRatingCounts", payload);
export const getFilterData = (payload) =>
  apiNode.post("/Doctor/SearchWebClone", payload);
export const getReferralDoctor = (payload) =>
  apiNode.post("/getRefDocByName", payload);
export const generatedPdfForAll = () => apiNode.post("/allDoctorDetailsNewPdf");
export const generatedPdfForSpecility = (payload) =>
  apiNode.post("/getDocDetailsBySpecialityPdf", payload);
export const generatedPdfForLocation = (payload) =>
  apiNode.post("/AllDoctorDetailsByCenter", payload);
export const needHelpCallBack = (payload) =>
  apiNode.post("/needHelpCallBack", payload);
export const postContactUs = (payload) =>
  apiNode.post("/postContactUs", payload);
export const getmanagementteam = (payload) =>
  apiNode.post("/getmanagementteam", payload);
export const getAllCenter = (payload) =>
  apiNode.post("/Doctor/Centre", payload);
export const getDoctorDetails = (payload) =>
  apiNode.post("/Doctor/Detail", payload);
export const getScheduleDates = (payload) =>
  apiNode.post("/Doctor/Schedule", payload);
export const getBookedSlots = (payload) =>
  apiOri.post("/Doctor/BookedSlots", payload);
export const bookAppointment = (payload) =>
  apiNode.post("/enterBookingData", payload);
export const getDoctorDirectorList = (payload) =>
  apiNode.post("getDoctorDirectorList", payload);
export const Speciality = (payload) =>
  apiNode.post("/Doctor/Speciality", payload);
export const getViewReport = (payload) =>
  apiNode.post("Patient/ReportDataNew", payload);
export const paymentForReport = (payload) => apiNode.post("/pay", payload);
export const updatePaymentStatus = (payload) =>
  apiNode.post("/RBD/PayUpdate", payload);
export const updateCorporatePaymentStatus = (payload) => apiNode.post("RBD/PayUpdateForCorporate", payload);
export const getGraphData = (payload) =>
  apiNode.post("/Patient/Graph", payload);
export const getGraphDetails = (payload) =>
  apiOri.post("Patient/GraphData", payload);
export const OurAllMember = (payload) =>
  apiNode.post("getInHouseDoctorListingInWeb", payload);
export const getNotification = (payload) =>
  apiNode.post("getNotification", payload);
export const getAboutUs = (payload) => apiNode.post("getAboutUs", payload);
export const getCallBack = (payload) =>
  apiNode.post("/needHelpCallBack", payload);
export const accountDeletionRequest = (payload) =>
  apiNode.post("accountDeletionRequest", payload);
export const UploadImage = (payload) =>
  apiNode.post("/bannerUploadS3", payload);
export const userLogin = (payload) => apiNode.post("/UserLogin", payload);
export const getBookingHistory = (payload) =>
  apiNode.post("/Patient/HCData", payload);
export const getOPDHistory = (payload) =>
  apiNode.post("/OPD/OPDBookingHistory", payload);

export const getFinancialYear = (payload) =>
  apiNode.post("/RBD/FinancialYears", payload);

export const getPastReport = (payload) =>
  apiNode.post("/Patient/ReportList", payload);

export const getTestAllowed = (payload) =>
  apiOri.post("/Patient/TestAllowed", payload);

export const getCompareData = (payload) =>
  apiOri.post("/Patient/GetComplist", payload);
export const getDownloadAllFile = (payload) =>
  apiNode.post("/autoAllDownload", payload);

export const GenerateOTPRegister = (payload) =>
  apiNode.post("/generateOTP", payload);

export const ValidateRegistedOtp = (payload) =>
  apiNode.post("/validateOTP", payload);

export const patientRegistration = (payload) =>
  apiNode.post("/Patient/Registration", payload);
export const getMedicine = (payload) =>
  apiOri.post("PatientMeditation", payload);
export const addMedicine = (payload) =>
  apiOri.post("AddPatientMeditation", payload);

export const generateOTP = (payload) =>
  apiNode.post("/Patient/GenerateOTP", payload);
export const validateOTP = (payload) =>
  apiNode.post("/Patient/ValidateOTP", payload);
export const ChangePwd = (payload) =>
  apiOri.post("/Patient/ChangePwd", payload);
export const updateProfile = (payload) =>
  apiNode.post("/Patient/UpdateProfile", payload);
export const getProfilebillData = (payload) =>
  apiNode.post("/Patient/ProPhleboBillData", payload);
export const reportStatus = (payload) => apiNode.post("/getCCView", payload);
export const getTestStatus = (payload) => apiNode.post("/getCCStatus", payload);
export const getBillIdWiseDownload = (payload) =>
  apiNode.post("/autoPdfDownload", payload);
export const getQrCodeforPayment = (payload) =>
  apiNode.post("/generateCorporateQrCode", payload);
export const verifyQrPaymentStatus = (payload) =>
  apiNode.post("/verifyCorporateQrPayment", payload);
export const getBulkReports = (payload) =>
  apiNode.post("/getAllReportsBucketLinksNew", payload);
export const payForCorporate = (payload) =>
  apiNode.post("/corporatePayNewSite", payload);
export const services = (payload) =>
  apiNode.post("/RBD/Corporate/Service", payload);
export const CreateBillwithSpecimen = (payload) =>
  apiOri.post("/RBD/CreateBillwithSpecimen", payload);
export const getReportByBillId = (payload) =>
  apiOri.post("Patient/ReportDataByID", payload);
export const getSpeciality = (payload) =>
  apiNode.post("/Doctor/Speciality", payload);
export const getPostJobWeb = (payload) =>
  apiNode.post("/getPostJobWeb", payload);
export const hiringApplicants = (payload) =>
  apiNode.post("/hiringApplicants", payload);
export const imageUploadCareerHiring = (payload) =>
  apiNode.post("/imageUploadCareerHiring", payload);
export const getBanner = (payload) =>
  apiNode.post("/getBanner", payload);
export const getDepartmentWiseCenter = (payload) =>
  apiNode.post("/getCenterNameByDept", payload);
export const submitFeedback = (payload) =>
  apiNode.post("/getFeedbackMail", payload);
export const fetchDeptList = (payload) =>
  apiNode.post("/getOrganListInWeb", payload);
export const sendMailByEnquiryForm = (payload) =>
  apiNode.post("/sendMailByEnquiryForm", payload);
export const getOrganwiseTests = (payload) =>
  apiNode.post("/getOrganMappingServiceTest", payload);
export const GetServiceDept = (payload) =>
  apiStaging.post("/GetServiceDept", payload);

export const serviceBranchDetails = (payload) =>
  apiOri.post("/RBD/MasterData", payload);

export const serviceDepartmentWise = (payload) =>
  apiStaging.post("/RBD/Service", payload);

export const ServiceTiming = (payload) =>
  apiStaging.post("/ServiceTiming", payload);
